export default "__VITE_ASSET__DnYGWyFY__"